import { render } from "./FormSearchSelect.vue?vue&type=template&id=15bb332c"
import script from "./FormSearchSelect.vue?vue&type=script&lang=js"
export * from "./FormSearchSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__